/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');

// Sliders
require('./app/sliders/resource-slider');
require('./app/sliders/testimonial-slider');
require('./app/sliders/scrolling-columns');
require('./app/sliders/video-slider');

// ScrollTrigger
// require('./app/scrollTrigger);

// App Requires
// require('./app/config');
// require('./app/helpers');
require('./app/general');
require('./app/primary-navigation');
require('./app/sticky-nav');
require('./app/filter-dropdown');
require('./app/resources');
require('./app/dropdown');
require('./app/auth');

// Blocks
require('./app/blocks/team-member-listing');
require('./app/blocks/scholarship-tabs');